import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {CCModalLayout, UserEntries} from './../../cc-imports'



class EntriesModal extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }

    render() {

        return (
            <CCModalLayout name={"Entries"} >
                <UserEntries></UserEntries>
            </CCModalLayout>
        )
    }
}

export default connect(state => ({

    }),
    (dispatch) => ({
        actions: bindActionCreators({}, dispatch),
        dispatch: dispatch
    })
)(EntriesModal);


// WEBPACK FOOTER //
// ./src/app/modals/EntriesModal/EntriesModal.js